import React from "react";

function BrandBanner() {
  return (
    <div
      className="w-full py-8 text-center"
      style={{ backgroundColor: "#5786ff" }}
    >
      <h2
        className="text-4xl md:text-5xl font-bold text-white tracking-wide"
        style={{ fontFamily: "'Signika Negative', sans-serif" }}
      >
        A PLUS FLAVOR
      </h2>
    </div>
  );
}

export default BrandBanner;
